import React, { useEffect, useState } from 'react';
import { EventContainer } from '../../../redux/EventContainer';
import VersionForceInteraction from '../../../../components/background-component-group/version-force-interaction/VersionForceInteraction';
import { EnvironmentVariables } from '../../../constants/EnvironmentVariables';
import { App } from '@capacitor/app';
import { ActionTypes } from '../../../actions/ActionTypes';
import { ActionSubTypes } from '../../../actions/ActionSubTypes';
import { Store } from '../../../redux/StoreContainer';
import { pUiVersionKontrol, rUiVersionKontrolSonuc } from '../../../api/models/.catalog';
import Actions from './../../../actions/ActionWrapper';
import { SecurityService } from '../../security';

export interface VersionControlOptions {
    onCloseAction?: 'close-app' | 'close-dialog',
}

const defaultVersionControlOptions: VersionControlOptions = {
    onCloseAction: 'close-app',
};

class _VersionController {
    private static _instance: _VersionController;

    private _init: boolean = false;

    public static Instance() {
        return this._instance || (this._instance = new this());
    }

    private onVersionControl = (evt: any, options?: VersionControlOptions | undefined): void => {
        const state = Store.getState();
        const versionState = state.uiVersionKontrolReducer;
        if (versionState.Data?.GuncellemeVarMi === true) {
            this.setVersionDialogBox(versionState.Data);
        }
    }

    private setVersionDialogBox = (data: rUiVersionKontrolSonuc | undefined, options?: VersionControlOptions | undefined): void => {
        const evt = EventContainer.CreateCustomEvent('trigger', { show: true, link: data?.GuncellemeLinki, versiyonIsmi: data?.VersiyonIsmi, versiyonKodu: data?.VersiyonKodu, options: options });
        EventContainer.DispatchEvent(evt, 'VersionControlServices_SetVersionDialogBox');
    }

    public enableControlVersion = (options?: VersionControlOptions | undefined): void => {
        if (this._init === false) {
            EventContainer.getEventTarget(ActionTypes.ASYNC_COMPLETE + '_' + ActionSubTypes.API_UIVERSIONKONTROL).removeEventListener();
            EventContainer.getEventTarget(
                ActionTypes.ASYNC_COMPLETE + '_' + ActionSubTypes.API_UIVERSIONKONTROL
            ).addEventListener('change', (evt) => {
                this.onVersionControl(evt, options);
            });
        }
        this._init = true;
    };

    public controlVersion = (): void => {
        const PUiVersionKontrol = new pUiVersionKontrol(
            {
                VersiyonIsmi: EnvironmentVariables.Build_Name,
                VersiyonKodu: EnvironmentVariables.Build_Code,
                IsletimSistemiAdi: EnvironmentVariables.Platform,
            });
        Store.dispatch(Actions.Api.User.UiVersionKontrol.asyncStart(PUiVersionKontrol));
    }
}

export const enableControlVersion = _VersionController.Instance().enableControlVersion;
export const controlVersion = _VersionController.Instance().controlVersion;


export const VersionControlService = (options?: VersionControlOptions | undefined) => {
    const _options = { ...defaultVersionControlOptions, ...options };

    const [state, setState] = useState<{
        show: boolean;
        link: string | undefined;
        VersiyonIsmi: number;
        VersiyonKodu: number;
        onCloseAction: 'close-app' | 'close-dialog' | undefined;
    }>({ show: false, link: undefined, VersiyonIsmi: 0, VersiyonKodu: 0, onCloseAction: _options.onCloseAction });

    const iosDownloadButton = React.createRef<HTMLAnchorElement>();
    const androidDownloadButton = React.createRef<HTMLAnchorElement>();

    const _setVersionDialogBox = (show: boolean, link: string | undefined, versiyonIsmi: number, versiyonKodu: number, options?: VersionControlOptions | undefined) => {
        if (show === true) {
            const __options = { ..._options, ...options };
            setState({ show: true, link: link, VersiyonIsmi: versiyonIsmi, VersiyonKodu: versiyonKodu, onCloseAction: __options.onCloseAction });
        } else {
            setState({ show: false, link: link, VersiyonIsmi: versiyonIsmi, VersiyonKodu: versiyonKodu, onCloseAction: _options.onCloseAction });
        }
    };

    const _onCloseApp = (options?: VersionControlOptions | undefined): void => {
        if (EnvironmentVariables.Platform === 'android') {
            App.exitApp();
        } else if (EnvironmentVariables.Platform === 'ios') {
            (navigator as any)['app'].exitApp()
        }
        return undefined;
    }
    const _onCloseDialog = (options?: VersionControlOptions | undefined): void => _setVersionDialogBox(false, undefined, 0, 0, options);

    const _onClose = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
        e.preventDefault();
        if (state.onCloseAction === 'close-app') {
            _onCloseApp(_options);
        } else if (state.onCloseAction === 'close-dialog') {
            _onCloseDialog(_options);
        }
    }

    const _onAccept = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        if (EnvironmentVariables.Platform === 'android' && typeof window !== 'undefined') {
            androidDownloadButton.current?.click();
        } else if (EnvironmentVariables.Platform === "ios") {
            iosDownloadButton.current?.click();
        }
    }

    useEffect(() => {
        EventContainer.getEventTarget('VersionControlServices_SetVersionDialogBox').addEventListener(
            'trigger',
            (e: any) => {
                _setVersionDialogBox(e.detail.show, e.detail.link, e.detail.versiyonIsmi, e.detail.VersiyonKodu, e.detail.options);
            }
        );
        return () => {
            EventContainer.getEventTarget('VersionControlServices_SetVersionDialogBox').removeEventListener('trigger');
        };
    }, []);

    if (state.show === true) {
        if (EnvironmentVariables.Platform === 'android') {
            return <>
                <VersionForceInteraction
                    onClose={_onClose}
                    onAccept={_onAccept}
                ></VersionForceInteraction>
                <div style={{ display: 'none' }}>
                    <a
                        ref={androidDownloadButton}
                        download={`OYAK_GFYS_v.${state.VersiyonIsmi}.${state.VersiyonKodu}.apk`}
                        href={SecurityService.SanitizeInnerHtml(EnvironmentVariables.Api_Default_Base_Url + (state.link || ''))
                        }>Kur CBS</a>
                </div>
            </>
        } else if (EnvironmentVariables.Platform === "ios") {
            return <>
                <VersionForceInteraction
                    onClose={_onClose}
                    onAccept={_onAccept}
                ></VersionForceInteraction>
                <div style={{ display: 'none' }}>
                    <a
                        ref={iosDownloadButton}
                        href={SecurityService.SanitizeInnerHtml(
                            `itms-services://?action=download-manifest&url=${(EnvironmentVariables.Api_Default_Base_Url + (state.link || ''))}`
                        )}>Kur CBS</a>
                </div>
            </>
        }
    }
    return <></>;
};